import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '@devseed-ui/theme-provider';

import UniversalGridder from '$styles/universal-gridder';
import { MediaCaption } from '$components/media';
import { BrowserFrame, BrowserFrameProps } from '$components/browser-frame';


const BrowserMediaWrapper = styled(UniversalGridder)`
  ${({ $isNested }) =>
    $isNested &&
    css`
      display: block;

      .browser-frame {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    `}

  .browser-frame {
    ${({ $contentSize }) => {
      if ($contentSize === 'cover') {
        return css`
          grid-column: full-start / full-end;
        `;
      }
      if ($contentSize === 'large') {
        return css`
          grid-column: content-start / content-end;
        `;
      }
      return css`
        grid-column: content-start / span 4;

        ${media.mediumUp`
          grid-column: content-start / span 8; 
        `}

        ${media.largeUp`
          grid-column: content-3 / span 8; 
        `}
      `;
    }}
  }
`;

interface BrowserMediaProps extends Omit<BrowserFrameProps, 'children'> {
  src: string | { default: string };
  alt?: string;
  size?: 'large' | 'cover' | 'default';
  isNested?: boolean;
  children?: React.ReactNode;
}

export function BrowserMedia(props: BrowserMediaProps) {
  const { src, alt, isNested, size = 'default', children, ...rest } = props;
  const mediaSrc = typeof src === 'string' ? src : src.default;

  const content = mediaSrc.endsWith('.mp4') ? (
    <video width='auto' controls>
      <source src={mediaSrc} type='video/mp4' />
      Your browser does not support the video tag.
    </video>
  ) : (
    <img src={mediaSrc} alt={alt} />
  );

  return (
    <BrowserMediaWrapper $contentSize={size} $isNested={isNested}>
      <figure className='browser-frame'>
        <BrowserFrame {...rest}>{content}</BrowserFrame>
        {children && <MediaCaption>{children}</MediaCaption>}
      </figure>
    </BrowserMediaWrapper>
  );
}

BrowserMedia.displayName = 'BrowserMedia';
